import { Component, Input } from '@angular/core';

@Component({
  selector: 'side-panel-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss'],
})
export class MobileComponent {
  @Input() config: unknown;
  @Input() memberContext: unknown;

  isOverviewModalOpen = false;
}
